import React from 'react';
import { m as motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { FULL_MOCKUP_URL } from '../data/images';
import { BASE_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-mp-black py-20 md:py-28" data-id="element-58" data-mp="m46pcjjah8pb">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-40" aria-hidden="true" data-id="element-59" data-mp="h6569ylv59du" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(ellipse at 50% 20%, rgba(8,93,168,0.3), transparent 65%)'
    }} aria-hidden="true" data-id="element-60" data-mp="vui4l28fb4bi" />
      <Container className="relative z-10 text-center" data-id="element-61" data-mp="14uwt0agoozj8">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-62" data-mp="14tdcqjv12ohg">
          <SectionTag tone="white" data-id="element-63" data-mp="2h3hnymusku5b">La próxima clase llegará igualmente.</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-64" data-mp="2h5kldry9xpk2">
            La pregunta es si volverás a improvisarla.
          </h2>

          <p className="mx-auto mt-6 max-w-[600px] text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-65" data-mp="2v3iryb6cshp0">
            Necesitas saber qué trabajar, por qué trabajarlo, cómo corregirlo y qué viene después. Eso es Maestro
            en Pista.
          </p>

          <p className="mx-auto mt-5 max-w-[600px] text-xs uppercase tracking-wide text-mp-gray/70 md:text-sm" data-id="element-66" data-mp="34tu6ernny9a5">
            5 tomos · 250+ páginas · 5 bonos · Garantía 14 días · El precio de un menú del día.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista" width={600} height={600} loading="lazy" className="mx-auto mt-12 w-full max-w-[380px]" data-id="element-67" data-mp="3it3awu2ibeya" />

        <div className="mx-auto mt-10 max-w-[420px] rounded-2xl border-2 border-mp-lime bg-mp-dark/80 p-7 shadow-glow-lime" data-id="element-68" data-mp="1novrsdj8og1d">
          <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-69" data-mp="22d02au851l92">Maestro en Pista</p>
          <p className="mt-3 font-heading text-5xl text-mp-lime" data-id="element-70" data-mp="1xfi49yvnsqfu">16,99 €</p>
          <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-71" data-mp="2be80zdekgo3o">Pago único</p>
          <CTAButton href={BASE_CHECKOUT_URL} className="mt-5 w-full" showArrow data-id="element-72" data-mp="27f8x7w4kmxdt">
            Quiero empezar
          </CTAButton>
        </div>

        <p className="mt-6 text-center text-xs text-mp-gray sm:text-sm" data-id="element-73" data-mp="czwkujprxo9f">
          💳 Pago único &nbsp;·&nbsp; ⚡ Acceso inmediato &nbsp;·&nbsp; 🛡️ Garantía 14 días &nbsp;·&nbsp; Sin
          suscripción
        </p>
      </Container>
    </section>;
}